var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-jobs"}},[_c('memlist-card',[_c('h5',{staticClass:"m-4"},[_vm._v("Körningar")]),_c('div',[_c('JobTable',{staticClass:"mb-8",attrs:{"type":"ALL"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }